import React, { Component } from 'react'
import { filter } from 'lodash'
import Card from './Card'
import Heading from './Heading'
import List, { ListItem } from './List'

type ItemCardItemName = 'purchaseOrder' |
  'workOrder' |
  'code' |
  'description' |
  'cpp' |
  'qpc' |
  'ppp' |
  'vendor' |
  'remainingCases' |
  'remainingQuantity' |
  'lastPallet' |
  'lastPalletNumber' |
  'caseQuantity' |
  'quantity' |
  'availableCasesOnPallet' |
  'availableQuantitesOnCase' |
  'safetyStock' |
  'upc'

interface ItemCardItem {
  name: ItemCardItemName
  meta: boolean
  text: string
  value: any
}

export interface ItemCardData {
  code: string
  description: string
  cpp: number
  qpc: number
  upc?: number
  ppp?: number
  vendor?: string
  heading?: string
  remainingCases?: number
  remainingQuantity?: number
  lastPallet?: string | null
  lastPalletNumber?: number | null
  caseQuantity?: number
  quantity?: number
  purchaseOrder?: string
  workOrder?: string
  availableCasesOnPallet?: string
  availableQuantitesOnCase?: number
  safetyStock?: number
}

interface ItemCardProps extends ItemCardData {}

export default class ItemCard extends Component<ItemCardProps> {
  get itemsData (): ItemCardItem[] {
    return [
      {
        name: 'code',
        meta: false,
        text: 'Code',
        value: this.props.code
      },
      {
        name: 'description',
        meta: false,
        text: 'Description',
        value: this.props.description
      },
      {
        name: 'cpp',
        meta: false,
        text: 'Cases per pallet',
        value: this.props.cpp
      },
      {
        name: 'qpc',
        meta: false,
        text: 'Quantity per case',
        value: this.props.qpc
      },
      {
        name: 'vendor',
        meta: false,
        text: 'Vendor',
        value: this.props.vendor
      },
      {
        name: 'remainingCases',
        meta: true,
        text: 'Cases remaining',
        value: this.props.remainingCases
      },
      {
        name: 'remainingQuantity',
        meta: true,
        text: 'Remaining quantity',
        value: this.props.remainingQuantity
      },
      {
        name: 'lastPallet',
        meta: true,
        text: 'Last pallet code',
        value: this.props.lastPallet
      },
      {
        name: 'lastPalletNumber',
        meta: true,
        text: 'Last pallet number',
        value: this.props.lastPalletNumber
      },
      {
        name: 'caseQuantity',
        meta: true,
        text: 'Case quantity',
        value: this.props.caseQuantity
      },
      {
        name: 'quantity',
        meta: true,
        text: 'Quantity',
        value: this.props.quantity
      },
      {
        name: 'purchaseOrder',
        meta: true,
        text: 'Purchase order',
        value: this.props.purchaseOrder
      },
      {
        name: 'workOrder',
        meta: true,
        text: 'Work order',
        value: this.props.workOrder
      },
      {
        name: 'availableCasesOnPallet',
        meta: false,
        text: 'Available cases on pallet',
        value: this.props.availableCasesOnPallet
      },
      {
        name: 'availableQuantitesOnCase',
        meta: false,
        text: 'Available quantities on case',
        value: this.props.availableQuantitesOnCase
      },
      {
        name: 'safetyStock',
        meta: false,
        text: 'Safety stock',
        value: this.props.safetyStock
      },
      {
        name: 'ppp',
        meta: false,
        text: 'Pieces per pack',
        value: this.props.ppp
      },
      {
        name: 'upc',
        meta: false,
        text: 'UPC',
        value: this.props.upc
      }
    ]
  }

  itemClassName (meta: boolean) {
    const base = 'mr-1'
    const fontWeight = meta && 'font-medium'
    return `${base} ${fontWeight}`
  }

  item (item: ItemCardItem) {
    const { name, meta, text, value } = item
    const className = this.itemClassName(meta)
    return value &&
      <div
        key={name}>
        <span className={className}>{text}:</span>
        <span className="text-secondary">{value}</span>
      </div>
  }

  get heading () {
    return this.props.heading || 'Item'
  }

  get details (): ListItem[] {
    const items = filter(this.itemsData, { meta: false })
    return items.map(item => {
      const { text, value } = item
      return { key: text, value }
    })
  }

  get meta (): ListItem[] {
    const items = filter(this.itemsData, { meta: true })
    return items.map(item => {
      const { text, value } = item
      return { key: text, value, highlight: true }
    })
  }

  render () {
    return (
      <Card>
        <Heading
          className="mb-2"
          text={this.heading} />
        <div className="mb-2">
          <List items={this.details} />
        </div>
        <List items={this.meta} />
      </Card>
    )
  }
}
